import type { KeyboardEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { palette } from '../../styles/tokens';
import { useAdminSetupBeacon } from '../../hooks/useAdminSetupBeacon';

export function SetupBeacon() {
  const navigate = useNavigate();
  const { completedCount, totalCount, fractionDone, nextStep, isFullySetup, loading } = useAdminSetupBeacon();

  if (isFullySetup || loading) return null;

  const open = () => { void navigate('/setup'); };
  const onKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      open();
    }
  };

  const pct = Math.round(fractionDone * 100);

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label="Open setup guide"
      onClick={open}
      onKeyDown={onKeyDown}
      style={{
        border: `1px solid ${palette.g150}`,
        borderRadius: 10,
        padding: 16,
        cursor: 'pointer',
        marginBottom: 12,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
        <div style={{ fontSize: 14, fontWeight: 600, color: palette.g800 }}>
          Finish setting up your business
        </div>
        <div style={{ fontSize: 12, fontWeight: 500, color: palette.g500 }}>
          {`${completedCount} of ${totalCount} done`}
        </div>
      </div>
      <div style={{ height: 6, borderRadius: 3, background: palette.accentWash, overflow: 'hidden' }}>
        <div style={{ width: `${pct}%`, height: 6, borderRadius: 3, background: palette.accent }} />
      </div>
      {nextStep && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 8 }}>
          <div style={{ fontSize: 13, fontWeight: 500, color: palette.g600 }}>
            {`Next up: ${nextStep.title}`}
          </div>
          <ChevronRight size={16} color={palette.accent} />
        </div>
      )}
    </div>
  );
}
